/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useReducer, useCallback } from 'react';
import { getRegionFromState } from './utils/dataTransformers';
import { getBackendUrl } from 'Samarth Module/api/apiURL';

export const SamarthDashboardContext = createContext();
let apiBaseUrlPromise = null;

const getApiBaseUrl = async () => {
  if (!apiBaseUrlPromise) {
    apiBaseUrlPromise = Promise.resolve(getBackendUrl()).then(
      (url) => `${url}/api`
    );
  }
  return apiBaseUrlPromise;
};
// const API_BASE_URL = await getBackendUrl() + '/api';

const apiClient = {
  async request(endpoint, options = {}) {
    const API_BASE_URL = await getApiBaseUrl();

    const token = localStorage.getItem('auth_token');
    const config = {
      timeout: 320000,
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*',
        ...(token && { Authorization: `Bearer ${token}` }),
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, config);

      if (!response.ok) {
        switch (response.status) {
          case 401:
          case 403:
          case 404:
          case 500:
          default:
            break;
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  },

  async post(endpoint, data) {
    return this.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async get(endpoint) {
    return this.request(endpoint, {
      method: 'GET',
    });
  },
};


const kpiApiService = {
  async fetchMaiKpi(filters) {
    const response = await apiClient.post('/kpi/mai', { 
        global_filters: {...filters.globalFilters , ...(filters?.globalFilters?.FG_NUMBER ? { Basepack : filters?.globalFilters?.FG_NUMBER } : {})|| []},
        kpi_filters: filters.actionFilters
          ? [
            typeof filters.actionFilters === 'string'
              ? (filters.actionFilters === "Factory" || filters.actionFilters === "Format" || filters.actionFilters === "SmallC") ? filters.actionFilters : 
              filters.actionFilters === "Segmentation" ? "HUL_Level_Segmentation" :
              filters.actionFilters.toUpperCase()
              : filters.actionFilters,
          ]
          : [],
    });
    return { data: response, filters: filters };
  },

  async fetchFgCoverage(filters) {
    const response = await apiClient.post('/kpi/fgCoverage/v2',  {
        global_filters: {...filters.globalFilters , ...(filters?.globalFilters?.FG_NUMBER ? { Basepack : filters?.globalFilters?.FG_NUMBER } : {})|| []},
        kpi_filters: filters.actionFilters
          ? [
              typeof filters.actionFilters === 'string'
              ? filters.actionFilters === "Factory" ? filters.actionFilters : 
              filters.actionFilters === "Segmentation" ? "HUL_Level_Segmentation" :
              filters.actionFilters.toUpperCase()
              : filters.actionFilters,
          ]
          : [],
      });

    return { data: response, filters: filters };
  },

  async fetchMstn(filters) {
    const response = await apiClient.post('/kpi/MstnFactoryDepot', { 
      global_filters: [], 
      kpi_filters: filters.actionFilters ? [typeof filters.actionFilters === 'string' ? filters.actionFilters.toUpperCase() : filters.actionFilters] : [] 
    });
    return { data: [response], filters: filters };
  },

  async fetchProjectedOR(filters) {
    const response = await apiClient.post('/kpi/ProjectedOR/v3', {
        global_filters: {...filters.globalFilters , Basepack : filters?.globalFilters?.FG_NUMBER || []},
        kpi_filters: filters.actionFilters
          ? [
               typeof filters.actionFilters === 'string'
              ? filters.actionFilters === "Factory" ? filters.actionFilters : 
              filters.actionFilters.toUpperCase()
              : filters.actionFilters,
          ]
          : [],
      });

    return { data: response, filters: filters };
  },

  async fetchDispatchCompliance(filters) {
    const gf = { SMALLC : filters?.globalFilters?.SmallC, BG : filters?.globalFilters?.BG };
    if(filters?.globalFilters?.SmallC) delete filters?.globalFilters?.SmallC;
    if(filters?.globalFilters?.BG) delete filters?.globalFilters?.BG;
    const response = await apiClient.post('/kpi/DC/v2', { 
       global_filters: gf,
        kpi_filters: filters.actionFilter
          ? [
             typeof filters.actionFilter === 'string'
              ? filters.actionFilter === "Factory" ? filters.actionFilter : 
              filters.actionFilter.toUpperCase()
              : filters.actionFilter,
          ]
          : [],
     });
    return { data: response, filters: filters };
  },

  async fetchManpowerIndex(filters = { globalFilters: {}, actionFilters: '' }) {
    const params = this.buildQueryParams(filters);
    const response = await apiClient.post('/kpi/MP', { params });
    return { data: [response], filters: filters };
  },

  async fetchDayChart(filters) {
    const params = this.buildQueryParams(filters);
    return await apiClient.post('/kpi/day-chart', { params });
  },

  async fetchOlaChart(filters) {
    const params = this.buildQueryParams(filters);
    return await apiClient.post('/kpi/ola-chart', { params });
  },

  async fetchExternalDisruptions(filters) {
    const params = this.buildQueryParams(filters);
    return await apiClient.post('/kpi/ExternalDistruption', { params });
  },

  async fetchMapMarkers(filters) {
    const params = this.buildQueryParams(filters);
    return await apiClient.post('/kpi/map_alerts', { params });
  },
  async fetchOSAData(filters) {
    const response = await apiClient.post('/kpi/Osa/v2', { 
      global_filters: {...filters.globalFilters , ...(filters.globalFilters?.Basepack ? { Basepack : filters.globalFilters?.Basepack?.map((item) => item.split(" ")[0])} : {})},
      kpi_filters: filters.actionFilters ? [ typeof filters.actionFilters === 'string'
              ? filters.actionFilters === "Factory" ? filters.actionFilters : 
              filters.actionFilters.toUpperCase()
              : filters.actionFilters
            ] : [] 
    });
    return { data: response, filters: filters };
  },

  async fetchDRData(filters) {
    const response = await apiClient.post('/kpi/DR/v2',  {
        global_filters: {...filters.globalFilters , ...(filters.globalFilters?.Basepack ? { Basepack : filters.globalFilters?.Basepack?.map((item) => item.split(" ")[0])} : {})},
        kpi_filters: filters.actionFilters
          ? [
            typeof filters.actionFilters === 'string'
              ? filters.actionFilters === "Factory" ? filters.actionFilters : 
              filters.actionFilters.toUpperCase()
              : filters.actionFilters,
          ]
          : [],
      },);
    return { data: response, filters: filters };
  },

  async fetchD0Data(filters) {
    const response = await apiClient.post('/kpi/D0/v2', { 
      global_filters: {...filters.globalFilters , ...(filters.globalFilters?.Basepack ? { Basepack : filters.globalFilters?.Basepack?.map((item) => item.split(" ")[0])} : {})}, 
      kpi_filters: filters.actionFilters ? [ typeof filters.actionFilters === 'string'
              ? filters.actionFilters === "Factory" ? filters.actionFilters : 
              filters.actionFilters.toUpperCase()
              : filters.actionFilters] : [] 
    });
    return { data: response, filters: filters };
  },

  async fetchSalesIndex(filters) {
    const response = await apiClient.post('/kpi/salesIndex/v2', {
        global_filters: {
  ...(filters.globalFilters || {}),
  ...(filters?.globalFilters?.FG_NUMBER ? { Basepack : filters?.globalFilters?.FG_NUMBER } : {})
},
        kpi_filters: filters.actionFilters
          ? [
              typeof filters.actionFilters === 'string'
              ? filters.actionFilters === "Segmentation" ? "HUL_Level_Segmentation" :
              filters.actionFilters.toUpperCase()
              : filters.actionFilters,
          ] : [],
  });
    return { data: response, filters: filters };
  },

  async fetchWeeklyOr(filters) {
    const response = await apiClient.post('/kpi/weeklyor', { 
      global_filters: [], 
      kpi_filters: filters.actionFilters ? [typeof filters.actionFilters === 'string' ? filters.actionFilters.toUpperCase() : filters.actionFilters] : [] 
    });
    return { data: response, filters: filters };
  },

  async fetchGlobalFilterData(filters){

    function objectToQueryParams(obj) {
      const queryParams = new URLSearchParams();
      for (const key in obj) {
        const value = obj[key];
        if (Array.isArray(value)) {
          value.forEach(item => queryParams.append(key, item));
        } else if (value !== undefined && value !== null) {
          queryParams.append(key, value);
        }
      }
      return queryParams.toString();
    }

    const params = filters.globalFilters ? "" : objectToQueryParams(filters);
    const response = await apiClient.get(`/global-filters${params ? `?${params}` : ''}`,)
    return response;
  },

  buildQueryParams(filters) {
    const params = {};
    if (filters.globalFilters && Object.keys(filters.globalFilters).length > 0) {
      params.globalFilters = [];
    } else {
      params.globalFilters = [];
    }
    if (filters.actionFilters) {
      params.actionFilters = [filters.actionFilters];
    }
    return params;
  }
};

const initialState = {
  viewMode: {
    globalViewMode: "graph",
    chartViewModes: {}
  },
  filters: {
    globalFilters: {},
    actionFilter: null,
    mapFilters: {
      type: "RMPM Shortage"
    },
    weekFilter: 'Week 27',
    tdp: 'TDP 18'
  },
  dashboardData: {
    internalMarkers: {},
    tdpCurrent: ' ',
    weekCurrent: ' ',
    mai: [],
    fgCoverage: [],
    salesIndex: [],
    mstn: [
      { week: 'Week 18', value: 49, isCurrent: true },
      { week: 'Week 19', value: 43 },
      { week: 'Week 20', value: 23 },
      { week: 'Week 21', value: 65 },
    ],
    mstnFactory: [
      { week: 'Week 18', value: 19, isCurrent: true },
      { week: 'Week 19', value: 83 },
      { week: 'Week 20', value: 33 },
      { week: 'Week 21', value: 15 },
    ],
    projectedOR: [
      { day: 'Mon', plan: 83, actual: 50, projected: 0, abs: 40, dataType: 'actual' },
      { day: 'Tue', plan: 83, actual: 43, projected: 0, abs: 12, dataType: 'actual' },
      { day: 'Wed', plan: 83, actual: 0, projected: 30, isCurrent: true, abs: 0, dataType: 'projected' },
      { day: 'Thu', plan: 83, actual: 0, projected: 10, abs: 30, dataType: 'projected' },
      { day: 'Fri', plan: 83, actual: 0, projected: 90, abs: 23, dataType: 'projected' },
      { day: 'Sat', plan: 83, actual: 0, projected: 60, abs: 40, dataType: 'projected' },
      { day: 'Sun', plan: 83, actual: 0, projected: 70, abs: 100, dataType: 'projected' },
    ],
    projectedOrTable:[],
    weeklyOR: [],
    weeklyOrTable: [],
    dispatchCompliance: [
      { day: 'Thu', hrs24: 49, hrs48: 75 },
      { day: 'Fri', hrs24: 43, hrs48: 65 },
      { day: 'Sat', hrs24: 23, hrs48: 30 },
      { day: 'Sun', hrs24: 65, hrs48: 80 },
      { day: 'Mon', hrs24: 43, hrs48: 60 },
      { day: 'Tue', hrs24: 23, hrs48: 40 },
      { day: 'Wed', hrs24: 65, hrs48: 90, isCurrent: true },
    ],
    globalFilterData: {},
    manpowerIndex: [],
    secondaryCCF: [
      { day: 'Thu', value: 25 },
      { day: 'Fri', value: 10 },
      { day: 'Sat', value: 75 },
      { day: 'Sun', value: 60 },
      { day: 'Mon', value: 55 },
      { day: 'Tue', value: 65 },
      { day: 'Wed', value: 75, isCurrent: true },
    ],
    dayChart: [
      { day: 'Thu', value: 49 },
      { day: 'Fri', value: 43 },
      { day: 'Sat', value: 23 },
      { day: 'Sun', value: 65 },
      { day: 'Mon', value: 43 },
      { day: 'Tue', value: 23 },
      { day: 'Wed', value: 65, isCurrent: true },
    ],
    olaChart: [
      { day: 'Thu', value: 49 },
      { day: 'Fri', value: 43 },
      { day: 'Sat', value: 23 },
      { day: 'Sun', value: 65 },
      { day: 'Mon', value: 43 },
      { day: 'Tue', value: 23 },
      { day: 'Wed', value: 65, isCurrent: true },
    ],
    osaData: [],
    drData: [
      { tdp: 'TDP 10', value: 95.65 },
      { tdp: 'TDP 11', value: 94.24 },
      { tdp: 'TDP 12', value: 93.72 },
      { tdp: 'TDP 13', value: 81.09 },
      { tdp: 'TDP 14', value: 72.87 },
      { tdp: 'TDP 15', value: 64.4 },
    ],
    d0Data: [],
    externalDisruptions: [],
    mapMarkers: [],
    dispatchComplianceFilterData: [
      {
        day: 'Thu',
        isCurrent: false,
        data: [
          { type: 'HC', value: 49 },
          { type: 'B&W', value: 39 },
          { type: 'PC', value: 8 },
          { type: 'Foods', value: 11 },
        ],
      },
      {
        day: 'Fri',
        isCurrent: false,
        data: [
          { type: 'HC', value: 43 },
          { type: 'B&W', value: 44 },
          { type: 'PC', value: 39 },
          { type: 'Foods', value: 46 },
        ],
      },
      {
        day: 'Sat',
        isCurrent: false,
        data: [
          { type: 'HC', value: 74 },
          { type: 'B&W', value: 65 },
          { type: 'PC', value: 23 },
          { type: 'Foods', value: 37 },
        ],
      },
      {
        day: 'Sun',
        isCurrent: false,
        data: [
          { type: 'HC', value: 65 },
          { type: 'B&W', value: 14 },
          { type: 'PC', value: 7 },
          { type: 'Foods', value: 40 },
        ],
      },
      {
        day: 'Mon',
        isCurrent: false,
        data: [
          { type: 'HC', value: 65 },
          { type: 'B&W', value: 14 },
          { type: 'PC', value: 7 },
          { type: 'Foods', value: 40 },
        ],
      },
      {
        day: 'Tue',
        isCurrent: false,
        data: [
          { type: 'HC', value: 65 },
          { type: 'B&W', value: 14 },
          { type: 'PC', value: 7 },
          { type: 'Foods', value: 40 },
        ],
      },
      {
        day: 'Wed',
        isCurrent: true,
        data: [
          { type: 'HC', value: 65 },
          { type: 'B&W', value: 14 },
          { type: 'PC', value: 7 },
          { type: 'Foods', value: 40 },
        ],
      },
    ],
    isLoading: {
      all: true,
      mai: true,
      fgCoverage: true,
      salesIndex: true,
      mstn: false,
      projectedOR: true,
      dispatchCompliance: true,
      manpowerIndex: true,
      secondaryCCF: true,
      dayChart: true,
      olaChart: true,
      externalDisruptions: true,
      mapMarkers: true,
      dispatchComplianceFilterData: true,
      osaData: true,
      drData: true,
      d0Data: true,
      internalMarkers: true,
      weeklyOr: true,
      globalFilterData: true
    },
    error: {
      all: null,
      mai: null,
      fgCoverage: null,
      salesIndex: null,
      mstn: null,
      projectedOR: null,
      dispatchCompliance: null,
      manpowerIndex: null,
      secondaryCCF: null,
      dayChart: null,
      olaChart: null,
      externalDisruptions: null,
      mapMarkers: null,
      dispatchComplianceFilterData: null,
      osaData: null,
      drData: null,
      d0Data: null,
      internalMarkers: null,
      weeklyOr: null,
      globalFilterData: null
    }
  }
};

let currWeek = 'Week 27';
let currTDP = 'TDP 18';

function appReducer(state, action) {
  switch (action.type) {
    case 'SET_GLOBAL_VIEW_MODE':
      return {
        ...state,
        viewMode: {
          ...state.viewMode,
          globalViewMode: action.payload
        }
      };

    case 'SET_CHART_VIEW_MODE':
      return {
        ...state,
        viewMode: {
          ...state.viewMode,
          chartViewModes: {
            ...state.viewMode.chartViewModes,
            [action.payload.chartId]: action.payload.mode
          }
        }
      };

    case 'RESET_CHART_VIEW_MODES':
      return {
        ...state,
        viewMode: {
          ...state.viewMode,
          chartViewModes: {}
        }
      };

    case 'SET_GLOBAL_FILTERS':
      return {
        ...state,
        filters: {
          ...state.filters,
          globalFilters: action.payload
        }
      };

    case 'UPDATE_GLOBAL_FILTER':
      return {
        ...state,
        filters: {
          ...state.filters,
          globalFilters: {
            ...state.filters.globalFilters,
            [action.payload.key]: action.payload.value
          }
        }
      };

    case 'SET_WEEK_FILTER':
      return {
        ...state,
        filters: {
          ...state.filters,
          weekFilter: action.payload
        }
      };

    case 'RESET_GLOBAL_FILTERS':
      return {
        ...state,
        filters: {
          ...state.filters,
          globalFilters: {}
        }
      };

      case 'SET_NEW_GLOBAL_FILTERS':
        const newGlobalFilters = {...action.payload , Factory: action.payload["values_mapping"]};
        delete newGlobalFilters["values_mapping"];
        return {
          ...state,
          filters: {
            ...state.filters,
            globalFilters: newGlobalFilters
          }
        };

    case 'SET_ACTION_FILTER':
      return {
        ...state,
        filters: {
          ...state.filters,
          actionFilter: action.payload
        }
      };

    case 'RESET_ACTION_FILTER':
      return {
        ...state,
        filters: {
          ...state.filters,
          actionFilter: null
        }
      };

    case 'SET_MAP_FILTER':
      return {
        ...state,
        filters: {
          ...state.filters,
          mapFilters: action.payload
        }
      };

    case 'UPDATE_MAP_FILTER':
      return {
        ...state,
        filters: {
          ...state.filters,
          mapFilters: {
            ...state.filters.mapFilters,
            [action.payload.key]: action.payload.value
          }
        }
      };

    case 'RESET_MAP_FILTER':
      return {
        ...state,
        filters: {
          ...state.filters,
          mapFilters: {}
        }
      };

    case 'RESET_FILTERS':
      return {
        ...state,
        filters: {
          ...state.filters,
          globalFilters: {},
          actionFilter: null,
          mapFilters: {}
        }
      };

    case 'SET_CURRENT_TDP':
      return {
        ...state,
        filters: {
          ...state.filters,
          tdp: action.payload
        }
      };

    case 'UPDATE_CHART_DATA':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          [action.payload.chartId]: action.payload.data
        }
      };

    case 'RESET_LOADING_STATES':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: Object.keys(state.dashboardData.isLoading).reduce((acc, key) => {
            acc[key] = false;
            return acc;
          }, {})
        }
      };

    case 'RESET_ERROR_STATES':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          error: Object.keys(state.dashboardData.error).reduce((acc, key) => {
            acc[key] = null;
            return acc;
          }, {})
        }
      };

    case 'FETCH_OSA_DATA_PENDING':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, osaData: true },
          error: { ...state.dashboardData.error, osaData: null }
        }
      };

    case 'FETCH_OSA_DATA_FULFILLED':
      const osaPayload = action.payload.data;
      const osaFilters = action.payload.filters;
      let osaData;

      if (osaFilters.actionFilters?.length) {
        osaData = osaPayload.map((tdp) => {
          const label = tdp.TDP;
          const data = Array.isArray(tdp.data)
            ? tdp.data.map((chatPoint) => ({
                label: chatPoint.type,
                value: Math.min(chatPoint.value , 100),
              }))
            : [];
          return {
            label: label?.split(".")[0],
            data,
          };
        });
      } else {
        osaData = Object.keys(osaPayload[0]).map((key) => ({
          label: key.split(".")[0],
          value: Math.min(Number(Number(osaPayload[0][key]).toFixed(2)), 100),
        }));
      }

      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, osaData: false },
          osaData
        }
      };

    case 'FETCH_OSA_DATA_REJECTED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, osaData: false },
          error: { ...state.dashboardData.error, osaData: action.payload }
        }
      };

    case 'FETCH_DR_DATA_PENDING':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, drData: true },
          error: { ...state.dashboardData.error, drData: null }
        }
      };

    case 'FETCH_DR_DATA_FULFILLED':
      const drPayload = action.payload.data;
      const drFilters = action.payload.filters;
      let drData;
      if (drFilters.actionFilters?.length) {
        drData = drPayload.map((tdp) => {
          const label = tdp.TDP;
          const data = Array.isArray(tdp.data)
            ? tdp.data.map((chatPoint) => ({
                label: chatPoint.type,
                value: chatPoint.value,
              }))
            : [];
          return {
            label: label?.split(".")[0],
            data,
          };
        });
      } else {
        drData = Object.keys(drPayload[0]).map((key) => ({
          label: key,
          value: Number(Number(drPayload[0][key]).toFixed(2)),
          isCurrent: key === currTDP,
        }));
      }

      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, drData: false },
          drData
        }
      };

    case 'FETCH_DR_DATA_REJECTED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, drData: false },
          error: { ...state.dashboardData.error, drData: action.payload }
        }
      };

    case 'FETCH_D0_DATA_PENDING':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, d0Data: true },
          error: { ...state.dashboardData.error, d0Data: null }
        }
      };

    case 'FETCH_D0_DATA_FULFILLED':
      const d0Payload = action.payload.data;
      const d0Filters = action.payload.filters;
      const weekOrder = {
          "Mon": 1,
          "Tue": 2,
          "Wed": 3,
          "Thu": 4,
          "Fri": 5,
          "Sat": 6,
          "Sun": 7
        }
      let d0Data;
      //const dayToday = new Date().toLocaleString("en-US", { weekday: "short" });

      if (d0Filters.actionFilters?.length) {
        d0Data = d0Payload.map((tdp) => {
          const label = tdp.TDP;
          const data = Array.isArray(tdp.data)
            ? tdp.data.map((chatPoint) => ({
                label: chatPoint.type,
                value: Number(chatPoint.value || 0).toFixed(2),
              }))
            : [];
          return {
            label: label?.split(".")[0],
            data,
          };
        });
      } else {
        d0Data = Object.keys(d0Payload[0])
          .map((key) => ({
            [key.includes("TDP") ? "tdp" : "day"]:
              key.split(" ")[0].slice(0, 3) + " " + (key.split(" ")?.[1] || ""),
            value: Math.floor(Number(d0Payload[0][key])),
            _isTdp: key.includes("TDP"),
          }))
          .sort((a, b) => {
            if (a.day?.trim() === "Mon") return 1;
            if (b.day?.trim() === "Mon") return -1;
            if (a._isTdp && !b._isTdp) return -1;
            if (!a._isTdp && b._isTdp) return 1;
            if (!a._isTdp && !b._isTdp)
              return weekOrder[a.day.trim()] - weekOrder[b.day.trim()];
            return 0;
          });
      }

      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, d0Data: false },
          d0Data
        }
      };

    case 'FETCH_D0_DATA_REJECTED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, d0Data: false },
          error: { ...state.dashboardData.error, d0Data: action.payload }
        }
      };

    case 'REFRESH_ALL_KPI_DATA_PENDING':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, all: true },
          error: { ...state.dashboardData.error, all: null }
        }
      };

    case 'REFRESH_ALL_KPI_DATA_FULFILLED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, all: false }
        }
      };

    case 'REFRESH_ALL_KPI_DATA_REJECTED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, all: false },
          error: { ...state.dashboardData.error, all: 'Failed to refresh all KPI data' }
        }
      };

    case 'FETCH_MAI_KPI_PENDING':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, mai: true },
          error: { ...state.dashboardData.error, mai: null }
        }
      };

    case 'FETCH_MAI_KPI_FULFILLED':
      const payload = action.payload.data;
      const isFilter = action.payload.filters;
      const finalData = isFilter.actionFilters?.length
        ? convertWeekData(payload)
        : Object.keys(payload[0])
          .map((key) => ({
            week: key,
            value: payload[0][key],
            isCurrent: key === currWeek,
          }))
          .filter((data) => {
            const weekNum = parseInt(data.week.replace('Week ', ''));
            const currWeekNum = parseInt(currWeek.replace('Week ', ''));
            
            if (currWeekNum > 49) {
              return weekNum >= currWeekNum || weekNum <= (currWeekNum + 3) - 52;
            }
            
            return weekNum >= currWeekNum && weekNum <= currWeekNum + 3;
          })
          .sort((a, b) => {
            const weekNumA = parseInt(a.week.replace('Week ', ''));
            const weekNumB = parseInt(b.week.replace('Week ', ''));
            const currWeekNum = parseInt(currWeek.replace('Week ', ''));
            if (currWeekNum > 49) {
              if (weekNumA <= (currWeekNum + 3) - 52 && weekNumB <= (currWeekNum + 3) - 52) {
                return weekNumA - weekNumB;
              }
              if (weekNumA >= currWeekNum && weekNumB >= currWeekNum) {
                return weekNumA - weekNumB;
              }
              if (weekNumA >= currWeekNum && weekNumB <= (currWeekNum + 3) - 52) {
                return -1;
              }
              return 1;
            }            
            return weekNumA - weekNumB;
          });
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, mai: false },
          mai: finalData
        }
      };

    case 'FETCH_MAI_KPI_REJECTED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, mai: false },
          error: { ...state.dashboardData.error, mai: action.payload }
        }
      };

    case 'FETCH_FG_COVERAGE_PENDING':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, fgCoverage: true },
          error: { ...state.dashboardData.error, fgCoverage: null }
        }
      };

    case 'FETCH_FG_COVERAGE_FULFILLED':
      const fgPayload = action.payload.data;
      const fgFilters = action.payload.filters;
      console.log("fgPayload", fgPayload);
      const fgData = fgFilters.actionFilters?.length
        ? convertWeekData(fgPayload)
        : Object.keys(fgPayload[0])
          .map((key) => ({
            week: key,
            value: fgPayload[0][key],
            isCurrent: key === currWeek,
          }))
          .filter((data) => {
            const weekNum = parseInt(data.week.replace('Week ', ''));
            const currWeekNum = parseInt(currWeek.replace('Week ', ''));
            
            if (currWeekNum > 49) {
              return weekNum >= currWeekNum || weekNum <= (currWeekNum + 3) - 52;
            }
            
            return weekNum >= currWeekNum && weekNum <= currWeekNum + 3;
          })
          .sort((a, b) => {
            const weekNumA = parseInt(a.week.replace('Week ', ''));
            const weekNumB = parseInt(b.week.replace('Week ', ''));
            const currWeekNum = parseInt(currWeek.replace('Week ', ''));
            if (currWeekNum > 49) {
              if (weekNumA <= (currWeekNum + 3) - 52 && weekNumB <= (currWeekNum + 3) - 52) {
                return weekNumA - weekNumB;
              }
              if (weekNumA >= currWeekNum && weekNumB >= currWeekNum) {
                return weekNumA - weekNumB;
              }
              if (weekNumA >= currWeekNum && weekNumB <= (currWeekNum + 3) - 52) {
                return -1;
              }
              return 1;
            }            
            return weekNumA - weekNumB;
          });

      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, fgCoverage: false },
          fgCoverage: fgData
        }
      };

    case 'FETCH_FG_COVERAGE_REJECTED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, fgCoverage: false },
          error: { ...state.dashboardData.error, fgCoverage: action.payload }
        }
      };

    case 'FETCH_SALES_INDEX_PENDING':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, salesIndex: true },
          error: { ...state.dashboardData.error, salesIndex: null }
        }
      };

    case 'FETCH_SALES_INDEX_FULFILLED':
      const salesIndexPayload = action.payload.data;
      const salesIndexIsFilter = action.payload.filters;

        function transformSalesIndexData(data) {
          const transformedAbs = Object.keys(data.abs).map((key) => ({
            week: key,
            value:(Number(data.abs[key])).toFixed(2),
            isCurrent: key === currTDP,
          }));

          const transformedPercentage = Object.keys(data.perc).map((key) => ({
            week: key,
            value: (Number(data.perc[key])).toFixed(2),
            isCurrent: key === currTDP,
          }));

          return {
            abs: transformedAbs,
            percentage: transformedPercentage || []
          };
        }
        const transformedSalesData = salesIndexIsFilter.actionFilters?.length ? converSalesIndexData(salesIndexPayload[0]) : transformSalesIndexData(salesIndexPayload[0]);

      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, salesIndex: false },
          salesIndex: transformedSalesData
        }
      };

    case 'FETCH_SALES_INDEX_REJECTED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, salesIndex: false },
          error: { ...state.dashboardData.error, salesIndex: action.payload }
        }
      };

    case "FETCH_GLOBAL_FILTER_DATA_PENDING": 
    return {
      ...state,
      dashboardData: {
        ...state.dashboardData,
        isLoading: { ...state.dashboardData.isLoading, globalFilter: true },
        error: { ...state.dashboardData.error, globalFilter: null }
      }
    };
    
    case "FETCH_GLOBAL_FILTER_DATA_FULFILLED": 
    const globalFilter = action.payload.filters;
    globalFilter.weekFilter = "Week " + action.payload.metadata.current_week;
    currWeek = "Week " + action.payload.metadata.current_week;
    globalFilter.tdp = "TDP " + action.payload.metadata.current_tdp;
    currTDP = "TDP " + action.payload.metadata.current_tdp;
    return {
      ...state,
      dashboardData: {
        ...state.dashboardData,
        weekCurrent : currWeek,
        tdpCurrent: currTDP,
        isLoading: { ...state.dashboardData.isLoading, globalFilter: false },
        globalFilterData: globalFilter,
      }
    };

    case "FETCH_GLOBAL_FILTER_DATA_REJECTED": 
    return {
      ...state,
      dashboardData: {
        ...state.dashboardData,
        isLoading: { ...state.dashboardData.isLoading, globalFilter: false },
        error: { ...state.dashboardData.error, globalFilter: action.payload }
      }
    };

    case 'FETCH_MSTN_PENDING':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, mstn: true },
          error: { ...state.dashboardData.error, mstn: null }
        }
      };

    case 'FETCH_MSTN_FULFILLED':
      const mstnPayloadDepot = action.payload.data[0]['DEPOT'];
      const mstnPayloadFactory = action.payload.data[0]['FACTORY'];
      const mstnFilters = action.payload.filters.actionFilters?.length;

      const mstnDepotData = mstnFilters
        ? convertWeekData(mstnPayloadDepot)
        : Object.keys(mstnPayloadDepot).map((key) => ({
            week: key,
            value: Math.floor(Number(mstnPayloadDepot[key])),
            isCurrent: key === currWeek,
          }));

      const mstnFactoryData = mstnFilters
        ? convertWeekData(mstnPayloadFactory)
        : Object.keys(mstnPayloadFactory).map((key) => ({
            week: key,
            value: Math.floor(Number(mstnPayloadFactory[key])),
            isCurrent: key === currWeek,
          }));

      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, mstn: false },
          mstn: mstnDepotData,
          mstnFactory: mstnFactoryData
        }
      };

    case 'FETCH_MSTN_REJECTED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, mstn: false },
          error: { ...state.dashboardData.error, mstn: action.payload }
        }
      };

    case 'FETCH_PROJECTED_OR_PENDING':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, projectedOR: true },
          error: { ...state.dashboardData.error, projectedOR: null }
        }
      };

    case 'FETCH_PROJECTED_OR_FULFILLED':
      const orFilter = action.payload.filters.actionFilters?.length;
      const projectedOR = orFilter ? transformProjectedOrFilterData(action.payload.data.projectedOR.abs , true) : transformWeekData(action.payload.data.projectedOR.abs);
      const projectedOrTable = orFilter ? toProjectOrAction(action.payload.data.projectedOR) : transformProjectedOrTableData(action.payload.data.projectedOR.or);

      const weeklyOr = orFilter ? convertWeekDataForWeeklyOr(action.payload.data.weeklyOR.abs) : Object.keys(action.payload.data.weeklyOR.abs).map((key) => ({
            day: key,
            plan: action.payload?.data?.weeklyOR?.abs?.[key]?.planned_qty || 0,
            actual: action.payload?.data?.weeklyOR?.abs?.[key]?.actual_qty || 0,
            projected : action.payload?.data?.weeklyOR?.abs?.[key]?.projected_qty || 0,
            isCurrent: key === currWeek,
          })).sort((a, b) =>  Number(a.day.replace("Week " , '')) - Number(b.day.replace("Week ", '')));
        const weeklyOrTable = orFilter ? Array.isArray(action.payload.data.weeklyOR.or) ? action.payload.data.weeklyOR?.or.sort((a, b) =>  Number(a.week.replace("Week " , '')) - Number(b.week.replace("Week ", ''))).map((item) => ({ day : item.week, data : item.data.map((values)=> {
          return {
            type : values.type,
            value : {
              or : values.value
            }
          }
        }) , isCurrent: item.week === currWeek})) : [] : Object.keys(action.payload.data.weeklyOR.or).map((key) => ({
            day: key,
            abs: action.payload.data?.weeklyOR?.or?.[key],
            isCurrent: key === currWeek,
        })).sort((a, b) =>  Number(a.day.replace("Week " , '')) - Number(b.day.replace("Week ", '')));

      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, projectedOR: false },
          projectedOR: projectedOR,
          projectedOrTable: projectedOrTable,
          weeklyOr: weeklyOr,
          weeklyOrTable: weeklyOrTable
        }
      };

    case 'FETCH_PROJECTED_OR_REJECTED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, projectedOR: false },
          error: { ...state.dashboardData.error, projectedOR: action.payload }
        }
      };

    case 'FETCH_DISPATCH_COMPLIANCE_PENDING':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, dispatchCompliance: true },
          error: { ...state.dashboardData.error, dispatchCompliance: null }
        }
      };

    case 'FETCH_DISPATCH_COMPLIANCE_FULFILLED':
      const dispatchCompFilter = action.payload.filters.actionFilter?.length;
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, dispatchCompliance: false },
          dispatchCompliance: dispatchCompFilter ? transformDispatchComplianceFilterData(action.payload.data) : transformDispatchComplianceData(action.payload.data[0])
        }
      };

    case 'FETCH_DISPATCH_COMPLIANCE_REJECTED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, dispatchCompliance: false },
          error: { ...state.dashboardData.error, dispatchCompliance: action.payload }
        }
      };

    case 'FETCH_MANPOWER_INDEX_PENDING':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, manpowerIndex: true },
          error: { ...state.dashboardData.error, manpowerIndex: null }
        }
      };

    case 'FETCH_MANPOWER_INDEX_FULFILLED':
      const manpowerPayload = action.payload.data;
      const manpowerData = Object.keys(manpowerPayload[0])
        .map((key) => ({
          week: key.replace('week ', 'Week '),
          value: Math.floor(Number(manpowerPayload[0][key])),
          isCurrent: key.replace('week ', 'Week ') === currWeek,
        }))
        .filter((data) => {
          const weekNum = parseInt(data.week.replace('Week ', ''));
          const currWeekNum = parseInt(currWeek.replace('Week ', ''));
          return weekNum <= currWeekNum;
        });

      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, manpowerIndex: false },
          manpowerIndex: manpowerData
        }
      };

    case 'FETCH_MANPOWER_INDEX_REJECTED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, manpowerIndex: false },
          error: { ...state.dashboardData.error, manpowerIndex: action.payload }
        }
      };

    case 'FETCH_DAY_CHART_PENDING':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, dayChart: true },
          error: { ...state.dashboardData.error, dayChart: null }
        }
      };

    case 'FETCH_DAY_CHART_FULFILLED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, dayChart: false },
          dayChart: action.payload
        }
      };

    case 'FETCH_DAY_CHART_REJECTED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, dayChart: false },
          error: { ...state.dashboardData.error, dayChart: action.payload }
        }
      };

    case 'FETCH_OLA_CHART_PENDING':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, olaChart: true },
          error: { ...state.dashboardData.error, olaChart: null }
        }
      };

    case 'FETCH_OLA_CHART_FULFILLED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, olaChart: false },
          olaChart: action.payload
        }
      };

    case 'FETCH_OLA_CHART_REJECTED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, olaChart: false },
          error: { ...state.dashboardData.error, olaChart: action.payload }
        }
      };

    case 'FETCH_EXTERNAL_DISRUPTIONS_PENDING':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, externalDisruptions: true },
          error: { ...state.dashboardData.error, externalDisruptions: null }
        }
      };

    case 'FETCH_EXTERNAL_DISRUPTIONS_FULFILLED':
      const externalDisruptionsPayload = action.payload;
      const mapMarkersFromDisruptions = externalDisruptionsPayload?.risk_breakdown.map((disruption , id) =>
            ({
              id: `${disruption.lat} ${disruption.lng} ${id}`,
              lat: disruption.lat,
              lng: disruption.lng,
              type: 'yellow',
              facilities_affected : disruption.facilities_affected,
              risk_type: disruption.risk_type,
              city: disruption.city,
              state: disruption.state,
              region : getRegionFromState(disruption.state),
            }));

      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, externalDisruptions: false },
          externalDisruptions: externalDisruptionsPayload.incidents.filter((incident) => !incident.Incident_Headline.includes("Wipro Enterprises Private")),
          mapMarkers: mapMarkersFromDisruptions
        }
      };

    case 'FETCH_EXTERNAL_DISRUPTIONS_REJECTED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, externalDisruptions: false },
          error: { ...state.dashboardData.error, externalDisruptions: action.payload }
        }
      };

    case 'FETCH_MAP_MARKERS_PENDING':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, mapMarkers: true },
          error: { ...state.dashboardData.error, mapMarkers: null }
        }
      };

    case 'FETCH_MAP_MARKERS_FULFILLED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, mapMarkers: false },
          internalMarkers: action.payload
        }
      };

    case 'FETCH_MAP_MARKERS_REJECTED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, mapMarkers: false },
          error: { ...state.dashboardData.error, mapMarkers: action.payload }
        }
      };

    case 'FETCH_DISPATCH_COMPLIANCE_FILTER_DATA_PENDING':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, dispatchComplianceFilterData: true },
          error: { ...state.dashboardData.error, dispatchComplianceFilterData: null }
        }
      };

    case 'FETCH_DISPATCH_COMPLIANCE_FILTER_DATA_FULFILLED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, dispatchComplianceFilterData: false }
        }
      };

    case 'FETCH_DISPATCH_COMPLIANCE_FILTER_DATA_REJECTED':
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          isLoading: { ...state.dashboardData.isLoading, dispatchComplianceFilterData: false },
          error: { ...state.dashboardData.error, dispatchComplianceFilterData: action.payload }
        }
      };

    default:
      return state;
  }
}

function debounce(func, wait) {
  let timeout = null;
  return function executedFunction(...args) {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      func(...args);
      timeout = null;
    }, wait);
  };
}

function convertWeekData(payload) {
  const result = {};
  if(!Array.isArray(payload) || payload.length === 0) return [];
  payload?.forEach(({ week, data }) => {
    result[week] = data?.map((item) => ({
      week: item.type,
      value: Math.floor(Number(item.value)),
    }));
  });
  return [result];
}

function transformDispatchComplianceFilterData(data){
   const dataType = data?.DC_24hrs;

  const result = [];
  
  Object.keys(dataType).forEach((key) => {
    result.push({
      day : key,
      "hrs24" : dataType[key],
      "hrs48":data?.DC_48hrs?.[key]
    })
  })

  return result;
}

function transformDispatchComplianceData(data) {
  const dayMap = {
    Sunday: "Sun",
    Monday: "Mon",
    Tuesday: "Tue",
    Wednesday: "Wed",
    Thursday: "Thu",
    Friday: "Fri",
    Saturday: "Sat",
  };

  const orderedDays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const today = new Date().toLocaleString("en-US", { weekday: "short" });

  return orderedDays.map((day) => {
    return {
      day: dayMap[day],
      hrs24: data.DC_24hrs[dayMap[day]] ?? 0,
      hrs48: data.DC_48hrs[dayMap[day]] ?? 0,
      ...(dayMap[day] === today && { isCurrent: true }),
    };
  });
}


function converSalesIndexData(payload) {
   const result = {};
  payload.abs?.forEach(({ values, data }) => {
    result[data] = values.map((item) => ({
      week: item.type,
      value: Math.floor(Number(item.value))
    }));
  });
  payload?.perc?.forEach(({ values, data }) => {
    result[data] = values?.map((item , index ) => ({
      week: item.type,
      value: result?.[data]?.[index]?.value || 0,
      percentage: Math.floor(Number(item.value_1)),
    }));
  })
  return [result];
}

const transformProjectedOrFilterData = (data , isOr = false) => {

  if(!Array.isArray(data)) return [];

  const currDay = new Date().toLocaleString("en-US", { weekday: "long" });

  const currDayData = data?.find((item) => item.day === currDay);

  return currDayData?.data.map((item) => {
  return {
    day: item.type,
    ...(isOr
      ? {
          projected: item?.values?.projected ?? item?.values?.actual ?? 0,
          plan: item?.values?.plan ?? 0,
        }
      : {
          or: item?.achievement_percentage,
        }),
  };
});
}

function toProjectOrAction(raw) {
  const abbr = {
    Monday: 'Mon',
    Tuesday: 'Tue',
    Wednesday: 'Wed',
    Thursday: 'Thu',
    Friday: 'Fri',
    Saturday: 'Sat',
    Sunday: 'Sun',
  };
  const todayShort = new Date().toLocaleString('en-US', { weekday: 'short' });

  // Index the two slices by full day name so we can merge them
  const absByDay = Object.fromEntries(Array.isArray(raw.abs) ? raw.abs?.map(d => [d.day, d]) : []);
  const orByDay  = Object.fromEntries( Array.isArray(raw.or) ? raw.or?.map(d => [d.day, d]) : []);

  return Object.keys(absByDay).map(fullDay => {
    const absEntry = absByDay[fullDay];
    const orEntry  = orByDay[fullDay];

    return {
      day: abbr[fullDay] ?? fullDay,
      isCurrent: todayShort === (abbr[fullDay] ?? fullDay),
      data: absEntry.data.map(({ type, values }) => {
        // Find the matching block inside the “or” slice to grab achievement %
        const orMatch = orEntry?.data.find(d => d.type === type);

        return {
          type,
          value: {
            plan:   values.plan        ?? values.planned_qty ?? 0,
            actual: values.actual      ?? values.actual_qty  ?? 0,
            or:     Math.min(orMatch?.values.achievement_percentage ,100 )  ?? 0,
          },
        };
      }),
    };
  });
}

function transformProjectedOrTableData(input) {
  const longKeysToshortKeys = {
    "Monday": "Mon",
    "Tuesday": "Tue",
    "Wednesday": "Wed",
    "Thursday": "Thu",
    "Friday": "Fri",
    "Saturday": "Sat",
    "Sunday": "Sun"
  }

  const daysOrder = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

   const finalData =  daysOrder.map((day) => {
    const entry = input[day] || {};
    
    const result = {
      day : longKeysToshortKeys[day],
      abs: entry.achievement_percentage || 0,
      isCurrent : false
    };

    if (day === new Date().toLocaleString("en-US", { weekday: "long" })) {
      result.isCurrent = true;
    }

    return result;
  });
  return finalData;
}

function transformWeekData(input) {
  const longKeysToshortKeys = {
    "Monday": "Mon",
    "Tuesday": "Tue",
    "Wednesday": "Wed",
    "Thursday": "Thu",
    "Friday": "Fri",
    "Saturday": "Sat",
    "Sunday": "Sun"
  }

  const daysOrder = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

   const finalData =  daysOrder.map((day) => {
    const entry = input[day] || {};
    const plan = entry.plan ?? 0;
    const actual = entry.actual ?? 0;
    const projected = entry.projected ?? 0;

    const dataType = actual ? "actual" : "projected";

    const result = {
      day : longKeysToshortKeys[day],
      plan,
      actual,
      projected,
      abs: 0,
      dataType,
      isCurrent: false
    };

    if (day === new Date().toLocaleString("en-US", { weekday: "long" })) {
      result.isCurrent = true;
    }

    return result;
  });
  return finalData;
}

const convertWeekDataForWeeklyOr = (payload) => {
  const result = {};
  if(!Array.isArray(payload) || payload.length === 0) return [];
  payload?.forEach(({ week, data }) => {
    result[week] = data?.map((item) => ({
      week: item.type,
      plan: item?.values?.planned_qty,
      projected: item?.values?.projected_qty || item?.values?.actual_qty || 0,
    }));
  });
  return [result];
};

export function SamarthDashboardProvider({ children }) {
  const [state, dispatch] = useReducer(appReducer, initialState);

   const stateRef = React.useRef(state);
   React.useEffect(() => {
   stateRef.current = state;
   }, [state]);

  const getFiltersFromState = () => {
    return {
       globalFilters: stateRef.current.filters.globalFilters,
       actionFilters: stateRef.current.filters.actionFilter,
    };
  };

  const refreshAllKpiData = async () => {
    dispatch({ type: 'REFRESH_ALL_KPI_DATA_PENDING' });
    const filters = getFiltersFromState();
    try {
      await Promise.all([
        fetchMaiKpi(filters),
        fetchFgCoverage(filters),
        fetchOSAData(filters),
        fetchDRData(filters),
        fetchD0Data(filters),
        fetchSalesIndex(filters),
        fetchProjectedOR(filters),
      ]);
      dispatch({ type: 'REFRESH_ALL_KPI_DATA_FULFILLED' });
    } catch (error) {
      dispatch({ type: 'REFRESH_ALL_KPI_DATA_REJECTED', payload: error.message });
    }
  };

  const fetchAllKpiInitially = async () => {
    dispatch({ type: 'REFRESH_ALL_KPI_DATA_PENDING' });
    const filters = getFiltersFromState();
    try {
      await Promise.all([
        fetchMaiKpi(filters),
        fetchManpowerIndex(),
        fetchExternalDisruptions(filters),
        fetchFgCoverage(filters),
        fetchOSAData(filters),
        fetchDRData(filters),
        fetchD0Data(filters),
        fetchSalesIndex(filters),
        fetchMapMarkers(filters),
        fetchProjectedOR(filters),
      ]);
      dispatch({ type: 'REFRESH_ALL_KPI_DATA_FULFILLED' });
    } catch (error) {
      dispatch({ type: 'REFRESH_ALL_KPI_DATA_REJECTED', payload: error.message });
    }
  }

  const debouncedRefresh = debounce(() => {
      refreshAllKpiData();
    }, 300);

  const fetchMaiKpi = useCallback(async (filters) => {
    dispatch({ type: 'FETCH_MAI_KPI_PENDING' });

    try {
      const result = await kpiApiService.fetchMaiKpi(filters || getFiltersFromState());
      dispatch({ type: 'FETCH_MAI_KPI_FULFILLED', payload: result });
    } catch (error) {
      dispatch({ type: 'FETCH_MAI_KPI_REJECTED', payload: error.message });
    }
  }, [getFiltersFromState.actionFilters]);

  const fetchFgCoverage = useCallback(async (filters) => {
    dispatch({ type: 'FETCH_FG_COVERAGE_PENDING' });
    try {
      const result = await kpiApiService.fetchFgCoverage(filters || getFiltersFromState());
      console.log("fg coverage result" , result);
      dispatch({ type: 'FETCH_FG_COVERAGE_FULFILLED', payload: result });
    } catch (error) {
      dispatch({ type: 'FETCH_FG_COVERAGE_REJECTED', payload: error.message });
    }
  }, [getFiltersFromState.actionFilters]);

  const fetchMstn = useCallback(async (filters) => {
    dispatch({ type: 'FETCH_MSTN_PENDING' });
    try {
      const result = await kpiApiService.fetchMstn(filters || getFiltersFromState());
      dispatch({ type: 'FETCH_MSTN_FULFILLED', payload: result });
    } catch (error) {
      dispatch({ type: 'FETCH_MSTN_REJECTED', payload: error.message });
    }
  }, [getFiltersFromState.actionFilters]);

  const fetchProjectedOR = useCallback(async (filters) => {
    dispatch({ type: 'FETCH_PROJECTED_OR_PENDING' });
    try {
      const result = await kpiApiService.fetchProjectedOR(filters || getFiltersFromState());
      dispatch({ type: 'FETCH_PROJECTED_OR_FULFILLED', payload: result });
    } catch (error) {
      dispatch({ type: 'FETCH_PROJECTED_OR_REJECTED', payload: error.message });
    }
  }, [getFiltersFromState.actionFilters]);

  const fetchDispatchCompliance = useCallback(async (filters) => {
    dispatch({ type: 'FETCH_DISPATCH_COMPLIANCE_PENDING' });
    try {
      const result = await kpiApiService.fetchDispatchCompliance(filters || getFiltersFromState());
      dispatch({ type: 'FETCH_DISPATCH_COMPLIANCE_FULFILLED', payload: result });
    } catch (error) {
      dispatch({ type: 'FETCH_DISPATCH_COMPLIANCE_REJECTED', payload: error.message });
    }
  }, []);

  const fetchManpowerIndex = useCallback(async () => {
    dispatch({ type: 'FETCH_MANPOWER_INDEX_PENDING' });
    try {
      const result = await kpiApiService.fetchManpowerIndex();
      dispatch({ type: 'FETCH_MANPOWER_INDEX_FULFILLED', payload: result });
    } catch (error) {
      dispatch({ type: 'FETCH_MANPOWER_INDEX_REJECTED', payload: error.message });
    }
  }, [getFiltersFromState.actionFilters]);

  const fetchDayChart = useCallback(async (filters) => {
    dispatch({ type: 'FETCH_DAY_CHART_PENDING' });
    try {
      const result = await kpiApiService.fetchDayChart(filters || getFiltersFromState());
      dispatch({ type: 'FETCH_DAY_CHART_FULFILLED', payload: result });
    } catch (error) {
      dispatch({ type: 'FETCH_DAY_CHART_REJECTED', payload: error.message });
    }
  }, [getFiltersFromState.actionFilters]);

  const fetchOlaChart = useCallback(async (filters) => {
    dispatch({ type: 'FETCH_OLA_CHART_PENDING' });
    try {
      const result = await kpiApiService.fetchOlaChart(filters || getFiltersFromState());
      dispatch({ type: 'FETCH_OLA_CHART_FULFILLED', payload: result });
    } catch (error) {
      dispatch({ type: 'FETCH_OLA_CHART_REJECTED', payload: error.message });
    }
  }, [getFiltersFromState.actionFilters]);

  const fetchExternalDisruptions = useCallback(async (filters) => {
    dispatch({ type: 'FETCH_EXTERNAL_DISRUPTIONS_PENDING' });
    try {
      const result = await kpiApiService.fetchExternalDisruptions(filters || getFiltersFromState());
      console.log("external disruptions result" , result);
      dispatch({ type: 'FETCH_EXTERNAL_DISRUPTIONS_FULFILLED', payload: result });
    } catch (error) {
      dispatch({ type: 'FETCH_EXTERNAL_DISRUPTIONS_REJECTED', payload: error.message });
    }
  }, [getFiltersFromState.actionFilters]);

  const fetchMapMarkers = useCallback(async (filters) => {
    dispatch({ type: 'FETCH_MAP_MARKERS_PENDING' });
    try {
      const result = await kpiApiService.fetchMapMarkers(filters || getFiltersFromState());
      dispatch({ type: 'FETCH_MAP_MARKERS_FULFILLED', payload: result });
    } catch (error) {
      dispatch({ type: 'FETCH_MAP_MARKERS_REJECTED', payload: error.message });
    }
  }, [getFiltersFromState.actionFilters]);

  const fetchOSAData = useCallback(async (filters) => {
    dispatch({ type: 'FETCH_OSA_DATA_PENDING' });
    try {
      const result = await kpiApiService.fetchOSAData(filters || getFiltersFromState());
      dispatch({ type: 'FETCH_OSA_DATA_FULFILLED', payload: result });
    } catch (error) {
      dispatch({ type: 'FETCH_OSA_DATA_REJECTED', payload: error.message });
    }
  }, [getFiltersFromState.actionFilters]);

  const fetchDRData = useCallback(async (filters) => {
    dispatch({ type: 'FETCH_DR_DATA_PENDING' });
    try {
      const result = await kpiApiService.fetchDRData(filters || getFiltersFromState());
      dispatch({ type: 'FETCH_DR_DATA_FULFILLED', payload: result });
    } catch (error) {
      dispatch({ type: 'FETCH_DR_DATA_REJECTED', payload: error.message });
    }
  }, [getFiltersFromState.actionFilters]);

  const fetchD0Data = useCallback(async (filters) => {
    dispatch({ type: 'FETCH_D0_DATA_PENDING' });
    try {
      const result = await kpiApiService.fetchD0Data(filters || getFiltersFromState());
      dispatch({ type: 'FETCH_D0_DATA_FULFILLED', payload: result });
    } catch (error) {
      dispatch({ type: 'FETCH_D0_DATA_REJECTED', payload: error.message });
    }
  }, [getFiltersFromState.actionFilters]);

  const fetchSalesIndex = useCallback(async (filters) => {
    dispatch({ type: 'FETCH_SALES_INDEX_PENDING' });
    try {
      const result = await kpiApiService.fetchSalesIndex(filters || getFiltersFromState());
      dispatch({ type: 'FETCH_SALES_INDEX_FULFILLED', payload: result });
    } catch (error) {
      dispatch({ type: 'FETCH_SALES_INDEX_REJECTED', payload: error.message });
    }
  }, [getFiltersFromState.actionFilters]);

  const fetchWeeklyOrData = useCallback(async (filters) => {
    dispatch({ type: 'FETCH_WEEKLY_OR_DATA_PENDING' });
    try {
      const result = await kpiApiService.fetchWeeklyOr(filters || getFiltersFromState());
      dispatch({ type: 'FETCH_WEEKLY_OR_DATA_FULFILLED', payload: result });
    } catch (error) {
      dispatch({ type: 'FETCH_WEEKLY_OR_DATA_REJECTED', payload: error.message });
    }
  }, [getFiltersFromState.actionFilters]);

  const fetchGlobalFilters = async (filters) => {
    dispatch({ type: 'FETCH_GLOBAL_FILTER_DATA_PENDING' });
    try {
      const result = await kpiApiService.fetchGlobalFilterData(filters);
      dispatch({ type: 'FETCH_GLOBAL_FILTER_DATA_FULFILLED', payload: result });
    } catch (error) {
      dispatch({ type: 'FETCH_GLOBAL_FILTER_DATA_REJECTED', payload: error.message });
    }
  };

  const fetchInitialGlobalFilter = async () => {
    const filters = getFiltersFromState();
    try {
      await fetchGlobalFilters(filters).then(() => {
        fetchAllKpiInitially();
      });
    } catch (error) {
      dispatch({ type: 'REFRESH_ALL_KPI_DATA_REJECTED', payload: error.message });
    }
  }

  const setGlobalViewMode = useCallback((mode) => {
    dispatch({ type: 'SET_GLOBAL_VIEW_MODE', payload: mode });
  }, []);

  const setChartViewMode = useCallback((chartId, mode) => {
    dispatch({ type: 'SET_CHART_VIEW_MODE', payload: { chartId, mode } });
  }, []);

  const resetChartViewModes = useCallback(() => {
    dispatch({ type: 'RESET_CHART_VIEW_MODES' });
  }, []);

  const setGlobalFilters = useCallback((filters) => {
    dispatch({ type: 'SET_GLOBAL_FILTERS', payload: filters });
  }, []);

  const updateGlobalFilter = useCallback((key, value) => {
    dispatch({ type: 'UPDATE_GLOBAL_FILTER', payload: { key, value } });
  }, []);

  const resetGlobalFilters = useCallback(() => {
    dispatch({ type: 'RESET_GLOBAL_FILTERS' });
  }, []);

  const setNewGlobalFilters = useCallback((filters) => {
    dispatch({ type: 'SET_NEW_GLOBAL_FILTERS', payload: filters });
  }, []);

  const setActionFilter = useCallback((filter) => {
    dispatch({ type: 'SET_ACTION_FILTER', payload: filter });
    debouncedRefresh();
  }, [debouncedRefresh]);

  const resetActionFilter = useCallback(() => {
    dispatch({ type: 'RESET_ACTION_FILTER' });
    debouncedRefresh();
  }, [debouncedRefresh]);

  const setMapFilter = useCallback((filters) => {
    dispatch({ type: 'SET_MAP_FILTER', payload: filters });
  }, []);

  const updateMapFilter = useCallback((key, value) => {
    dispatch({ type: 'UPDATE_MAP_FILTER', payload: { key, value } });
  }, []);

  const resetMapFilter = useCallback(() => {
    dispatch({ type: 'RESET_MAP_FILTER' });
  }, []);

  const resetFilters = useCallback(() => {
    dispatch({ type: 'RESET_FILTERS' });
  }, []);

  const setCurrentTDP = useCallback((tdp) => {
    dispatch({ type: 'SET_CURRENT_TDP', payload: tdp });
  }, []);

  const setWeekFilter = useCallback((week) => {
    dispatch({ type: 'SET_WEEK_FILTER', payload: week });
  }, []);

  const updateChartData = useCallback((chartId, data) => {
    dispatch({ type: 'UPDATE_CHART_DATA', payload: { chartId, data } });
  }, []);

  const resetLoadingStates = useCallback(() => {
    dispatch({ type: 'RESET_LOADING_STATES' });
  }, []);

  const resetErrorStates = useCallback(() => {
    dispatch({ type: 'RESET_ERROR_STATES' });
  }, []);

  const value = {
    state,
    dispatch,
    fetchGlobalFilters,
    fetchInitialGlobalFilter,
    fetchMaiKpi,
    fetchFgCoverage,
    fetchMstn,
    fetchProjectedOR,
    fetchDispatchCompliance,
    fetchManpowerIndex,
    fetchDayChart,
    fetchOlaChart,
    fetchExternalDisruptions,
    fetchMapMarkers,
    fetchOSAData,
    fetchDRData,
    fetchD0Data,
    fetchSalesIndex,
    fetchWeeklyOrData,
    refreshAllKpiData,
    fetchAllKpiInitially,
    setNewGlobalFilters,
    setGlobalViewMode,
    setChartViewMode,
    resetChartViewModes,

    setGlobalFilters,
    updateGlobalFilter,
    resetGlobalFilters,
    setActionFilter,
    resetActionFilter,
    setMapFilter,
    updateMapFilter,
    resetMapFilter,
    resetFilters,
    setCurrentTDP,
    setWeekFilter,

    updateChartData,
    resetLoadingStates,
    resetErrorStates,
  };

  return <SamarthDashboardContext.Provider value={value}>{children}</SamarthDashboardContext.Provider>;
}